import { render, staticRenderFns } from "./DashBoardContentLayoutTemplate.vue?vue&type=template&id=d133983e&scoped=true&"
import script from "./DashBoardContentLayoutTemplate.vue?vue&type=script&lang=js&"
export * from "./DashBoardContentLayoutTemplate.vue?vue&type=script&lang=js&"
import style0 from "./DashBoardContentLayoutTemplate.vue?vue&type=style&index=0&id=d133983e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d133983e",
  null
  
)

export default component.exports